import client from "./instance";
import client2 from "./instanceNoLodding";
import client3 from "./instanceClientNoLodding"

export const encrypt = async (data) => {
  try {
    const response = await client.post(
      "/care-message-notification/encrypt",
      data,
    );

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const unread = async (data) => {
  try {
    const response = await client.post("/care-message-notification/unread");
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getNotiByActive = async (data) => {
  try {
    // 4plus Add client prefix to endpoint
    const response = await client3.post(
      "/care-message-notification/getNotiByActive",
      data,
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const readNoti = async (data) => {
  try {
    // 4plus Add client prefix to endpoint
    const response = await client3.post(
      "/care-message-notification/readNoti",
      data,
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const deleteNoti = async (data) => {
  try {
    // 4plus Add client prefix to endpoint
    const response = await client3.post(
      "/care-message-notification/deleteNoti",
      data,
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const updateNoti = async (data) => {
  try {
    const response = await client2.post(
      "/care-message-notification/updateNoti",
      data,
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getNotiByActiveAndId = async (data) => {
  try {
    // 4plus Add client prefix to endpoint
    const response = await client3.post(
      "/care-message-notification/getNotiByActiveAndId",
      data,
    );

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// connect car

export const getRegNoByTconnectId = async (data) => {
  try {
    // 4plus Add client prefix to endpoint
    const response = await client3.post(
      "/care-message-notification/getNotiRegNo",
      data,
    );

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getNotiByActiveV2 = async (data) => {
  try {
    const response = await client3.post(
      "/care-message-notification/getNotiByActiveV2",
      data,
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getNotiCategory = async (data) => {
  try {
    const response = await client3.post(
      "/care-message-notification/getNotiCategory",
      data,
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const updateAction = async (data) => {
  try {
    const response = await client3.post(
      "/care-message-notification/updateAction",
      data,
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const deleteAllNoti = async (data) => {
  try {
    const response = await client3.post(
      "/care-message-notification/deleteAllNoti",
      data,
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

